












































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

import { Chapter, Course, LoggedOutCoupon, Quiz } from 'frontend/types';
import Cover from 'frontend/views/courses/CoursePage/components/Cover.vue';
import ChaptersList from 'frontend/views/courses/CoursePage/components/ChaptersList.vue';
import DetailedDescription from 'frontend/views/courses/CoursePage/components/DetailedDescription.vue';
import OnboardingOverlay from 'frontend/views/courses/CoursePage/components/OnboardingOverlay.vue';
import CourseModal from 'frontend/views/courses/CoursePage/components/CourseModal.vue';
import { LearningPathCourse } from 'frontend/store/modules/next-learning-path-course';
import LLPDaisyChain from './components/LLPDaisyChain.vue';
import { RelatedLearningPathInfo } from 'frontend/types/learningPathV2';

@Component({
  components: {
    ChaptersList,
    CourseModal,
    Cover,
    DetailedDescription,
    OnboardingOverlay,
    LLPDaisyChain,
    LoggedOutCouponBanner: () =>
      // tslint:disable-next-line:space-in-parens max-line-length
      import(
        /* webpackChunkName: 'LoggedOutCouponBanner' */ 'frontend/views/courses/components/LoggedOutCouponBanner.vue'
      ),
  },
  computed: {
    ...mapState('course', ['course']),
    ...mapState('isFirstCourse', ['didNotStartALesson']),
    ...mapGetters('globals', ['isAuthenticated']),
    ...mapGetters('chapters', ['chapters']),
    ...mapGetters('showShoppingVersion', ['showShoppingVersion']),
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapGetters('loggedOutCoupon', ['activeLoggedOutCoupon']),
    ...mapGetters('nextLearningPathCourse', ['nextLearningPathCourse']),
    ...mapGetters('relatedLearningPathInfo', ['learningPath']),
  },
})
export default class CoursePage extends Vue {
  private readonly isAuthenticated!: boolean;
  private readonly showShoppingVersion!: boolean;
  private readonly didNotStartALesson!: boolean;
  private readonly course!: Course;
  private readonly chapters!: Chapter[];
  private readonly activeLoggedOutCoupon!: LoggedOutCoupon;
  private readonly learningPath?: RelatedLearningPathInfo;
  private readonly nextLearningPathCourse?: LearningPathCourse;

  private isOnboardingOverlayOpen: boolean = false;
  private isCourseModalOpen: boolean = false;

  private get isInLLPRolloutExperiment(): boolean {
    return !!this.learningPath;
  }

  private get hasPractice(): boolean {
    return this.chapters.some(chapter =>
      chapter.quizzes.some(lesson => lesson.practice_lessons.length),
    );
  }

  private get allMainLessons(): Quiz[] {
    return this.chapters.flatMap(chapter => chapter.quizzes);
  }

  private get previousLessonSlug(): string | undefined {
    const recommendedLessonIndex = this.allMainLessons.findIndex(
      lesson => lesson.slug === this.course.recommended_lesson_slug,
    );

    if (recommendedLessonIndex > 0) {
      return this.allMainLessons[recommendedLessonIndex - 1].slug;
    }
    return undefined;
  }

  private get shouldHighlightFirstLesson(): boolean {
    return this.isAuthenticated && this.didNotStartALesson;
  }

  private get showLoggedoutCouponBanner(): boolean {
    return !this.isAuthenticated && !!this.activeLoggedOutCoupon;
  }

  mounted(): void {
    if (this.shouldHighlightFirstLesson) {
      // This compensates some small layout shifts in the page when the page is loaded.
      setTimeout(() => (this.isOnboardingOverlayOpen = true), 500);
    }
  }
}
